import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class SharedAttachmentsService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    singleAttachmentInstance: BehaviorSubject<any> = new BehaviorSubject(null);

    /**
     * getAttachments() - Buscar conteúdos do tipo de sessão
     * @param departmentType : Id do departamento
     * @param sessionType : Tipo de sessão
     */
    getAttachments(departmentType, sessionType): Observable<any> {
        // Instancia do body através de BaseService.setBody();
        let body = this.setBody();

        // type: Definir o id do departamento para buscar de documentos e conteúdos
        body.set('departmentType', departmentType);

        // type: Definir o tipo de sessão para buscar de documentos e conteúdos
        body.set('sessionType', sessionType);

        let response = this.http
            .post(this.urlService + this.routeAdress.route_menu_content, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    getAttachmentsDetail(departmentType: string, sessionType: string, docId: string): Observable<any> {
        let body = this.setBody();

        // type: Definir o id do departamento para buscar de documentos e conteúdos
        body.set('departmentType', departmentType);

        // type: Definir o tipo de sessão para buscar de documentos e conteúdos
        body.set('sessionType', sessionType);

        body.set('sessionContentId', docId);

        let response = this.http
            .post(this.urlService + this.routeAdress.route_menu_content, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));
        return response;
    }
}
